/** @format */

import {
  Component,
  HostBinding,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';

import { CommonModule } from '@angular/common';
import { DCSG_CONSTANTS } from '@shared/data-access/constants';

@Component({
  selector: 'homefield-image-swatch',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './image-swatch.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './image-swatch.component.scss',
})
export class HomefieldImageSwatchComponent implements OnInit {
  @HostBinding('style.--colorSwatchRadius')
  imageSrc = input('');

  radius = input('');
  color = input('');
  altText = input('');
  height = input('');
  width = input('');
  selected = input(false);
  disabled = input(false);
  imageSwatchHoverDimension = input(false);

  imageSwatchError = output<string>();

  swatchAriaLabel = '';

  ngOnInit(): void {
    this.swatchAriaLabel = this.color() ? `Color Option: ${this.color()}` : '';
  }

  // Emitting image source to product swatch component.
  // Product swatch will have additional info
  // which will be suitable for the rumrunner custom event
  emitImageError(event): void {
    event.target.src = DCSG_CONSTANTS.imageUnavailable;
    this.imageSwatchError.emit(this.imageSrc());
  }

  attributeValueClicked(elem): void {
    elem.blur();
  }
}
